/**
 * Класс бейджа статуса стадии.
 * Серый: не в работе. Оранжевый: в работе. Зелёный: работы завершены / закрыта.
 * @param {string|null|undefined} status
 * @returns {'object-status-not-started'|'object-status-in-progress'|'object-status-completed'}
 */
export function getStageStatusClass(status) {
  if (status == null || String(status).trim() === '') return 'object-status-not-started'
  const s = String(status).toLowerCase().trim()
  if (s === 'работы завершены' || s === 'закрыта') return 'object-status-completed'
  if (s === 'в работе') return 'object-status-in-progress'
  if (s === 'не в работе') return 'object-status-not-started'
  return 'object-status-not-started'
}
